import { Modal, ModalContent, ModalFooter, Box, ModalOverlay } from '@chakra-ui/react';
import { Text, Button } from '@mercator-gcp/grout';

const contentStyle = {
  maxWidth: '500px',
  width: 'fit-content',
};

const titleStyle = {
  paddingBottom: 'padding_16',
};

const modalBodyStyle = {
  padding: 'padding_16',
  paddingBottom: '0px',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: 'padding_16',
};

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmUnsaveModal = ({ isOpen, onClose, onConfirm }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={contentStyle}>
        <Box sx={modalBodyStyle}>
          <Text.Lead sx={titleStyle}>
            Are you sure you want to hide this project?
          </Text.Lead>
          <Text>
            This will remove it from your collection and hide it from future searches.
          </Text>
        </Box>

        <ModalFooter sx={modalFooterStyle}>
          <Button variant="functional" onClick={onClose}>
            No, cancel
          </Button>
          <Button variant="alert" onClick={onConfirm}>
            Hide project
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmUnsaveModal;
